var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMerlin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92115_24403)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 34.7193C26.3381 34.7193 34.7193 26.3381 34.7193 15.9992C34.7193 5.66051 26.3381 -2.7207 15.9993 -2.7207C5.66054 -2.7207 -2.7207 5.66051 -2.7207 15.9992C-2.7207 20.711 -0.979971 25.0161 1.89348 28.3068L11.7182 19.1968C11.9802 18.8003 12.1778 18.3626 12.3019 17.9L12.3392 17.7606L6.90353 16.9526C6.26615 16.8579 6.26615 15.9387 6.90353 15.8439L11.7585 15.1223L6.13774 7.53888C5.75402 7.02119 6.40401 6.37121 6.9217 6.75492L14.5071 12.3773L15.2294 7.51811C15.3241 6.88072 16.2433 6.88072 16.338 7.51812L17.0597 12.3738L24.6404 6.75492C25.1581 6.37121 25.8081 7.02119 25.4245 7.53888L19.8041 15.1217L24.6639 15.8439C25.3012 15.9387 25.3012 16.8579 24.6639 16.9526L19.8041 17.6749L25.4245 25.2576C25.8081 25.7753 25.1581 26.4253 24.6404 26.0417L17.0597 20.4229L16.338 25.2785C16.2433 25.9158 15.3241 25.9158 15.2294 25.2784L14.421 19.8395L13.9625 19.9623C13.7071 20.0308 13.4656 20.1396 13.2467 20.2836L3.95847 30.3336C7.21338 33.0706 11.4139 34.7193 15.9993 34.7193Z",
    fill: "url(#paint0_linear_92115_24403)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_92115_24403",
    x1: -8.89638,
    y1: -0.614709,
    x2: 41.8638,
    y2: 26.7176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#6335FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD89FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92115_24403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerlin);
export default __webpack_public_path__ + "static/media/merlin.132db58c41925c774d7cde740fe2a2ca.svg";
export { ForwardRef as ReactComponent };